import type { BrandConfig } from './types'

/**
 * JPPA brand configuration.
 *
 * JPPA reuses Triplo M's (TMS) visual identity verbatim — logo, favicon,
 * background image, colors, and fonts are byte-for-byte/value-for-value
 * copies of {@link ../triploms.ts | triplomssBrand}. Only `name`, `hostname`,
 * and `title` differ, since those drive brand *detection* (host-based
 * routing) and page title — not appearance. If TMS's identity changes, mirror
 * the change here too.
 */
export const jppaBrand: BrandConfig = {
  name: 'JPPA',
  hostname: 'app.jppa.triploms.com',

  logoUrl: '/brands/jppa/logo.png',
  faviconUrl: '/brands/jppa/favicon.png',
  title: 'JPPA',

  googleFontsUrl: '',

  colors: {
    light: {
      text: '#000000',
      textH: '#000000',
      bg: '#f6f8fb',
      border: '#d7dce3',
      codeBg: '#f6f8fb',
      accent: '#0270C0',
      accentBg: 'rgba(2, 112, 192, 0.10)',
      accentBorder: 'rgba(2, 112, 192, 0.24)',
      socialBg: '#f6f8fb',
      shadow: 'rgba(0, 0, 0, 0.08)',
    },
    dark: {
      text: '#000000',
      textH: '#000000',
      bg: '#f6f8fb',
      border: '#d7dce3',
      codeBg: '#f6f8fb',
      accent: '#0270C0',
      accentBg: 'rgba(2, 112, 192, 0.10)',
      accentBorder: 'rgba(2, 112, 192, 0.24)',
      socialBg: '#f6f8fb',
      shadow: 'rgba(0, 0, 0, 0.08)',
    },
  },

  fonts: {
    sans: 'Arial, Helvetica, sans-serif',
    heading: 'Arial, Helvetica, sans-serif',
    mono: 'ui-monospace, Consolas, monospace',
  },
}
